(function () {
    "use strict";

    angular.module('app').factory('IvmScreeningRemarkValidator', IvmScreeningRemarkValidator);

    /**
     * Creates a service for validating IVM Screening remarks.
     * These remarks have an interface
     * {
     *    Subject: CodeIVMSections,
     *    IsValid: bool,
     *    Description: String
     * }
     */
    function IvmScreeningRemarkValidator() {
        return {
            HasInvalidRemark: hasInvalidRemark,
            HasInvalidRemarkForSection: hasInvalidRemarkForSection
        };

        function hasInvalidRemark(remarks) {
            if (!Array.isArray(remarks))
                return false;
            return remarks.some(isRemarkInvalid);
        }

        function isRemarkInvalid(remark) {
            return !remark.IsValid && remark.Description && remark.Description.length > 0;
        }

        function hasInvalidRemarkForSection(remarks, section) {
            if (!Array.isArray(remarks))
                return false;
            if (!section)
                return false;

            return remarks.some(r => r.Subject === section && isRemarkInvalid(r));
        }
    }
})();
